import { Domain } from "./Domain";
export const BASE_API_URL = "https://estbn.com/EstbnNew/public/api/";
export const CREATE_ACCOUNT = Domain + "portal/operator/login";
// export const OPERATORS_LOGIN = Domain + "portal/operator/login";
export const OPERATORS_LOGIN = Domain + "portal/stuff/login";
export const VEHICLES_LIST = Domain + "portal/door_step_vehicles";
export const VAN_PROFILE = Domain + "portal/door_step_vehicles";
export const ORDER = Domain + "portal/orders";
export const CREATE_VEHICLE = Domain + "portal/door_step_vehicles";
export const CAR_SPECIFICATION = Domain + "car/specifications";
export const VEHICLE_TYPE = Domain + "portal/vehicle_types";
export const CREATE_NEW_STUFF = Domain + "portal/stuffs";
export const GET_ALL_STAFF_USERS = Domain + "portal/stuffs";
export const POST_LICENSE = Domain + "driver_licenses";
export const POST_LINCESE_INSURANCE = Domain + "portal/insurances";
export const POST_LINCESE_INSPECTION = Domain + "portal/inspections";
export const GET_ALL_TITLE_JOPES = Domain + "portal/job_titles";
export const GET_ALL_OPERATER_USERS =
  "https://estbn.com/EstbnNew/public/api/portal/operators";
export const GET_ALL_VEHICLE_ORDERS = Domain + "portal/vehicle_orders";
export const GET_ORDERS_DATA_TO_ASSIGN_TO_VEHICLE = Domain + "portal/orders";
export const EQUIPMENTS_CARD = Domain + "portal/equipments";
// export const MAIN_SERVICE_CATEGORIES = Domain + "service_categories";
export const MAIN_SERVICE_CATEGORIES =
  Domain + "portal/doorstep-service-categories";
export const VEHICLE_SERVICES = Domain + "portal/vehicle_services";
export const EQUIPMENT_SERVICES = Domain + "portal/equipment_services";
export const JOBS_TITLE = Domain + "portal/job_titles";
export const VEHICLE_STUFF = Domain + "portal/vehicle_stuffs";
export const VEHICLE_STUFFS_TRANSFER =
  Domain + "portal/vehicle_stuffs_transfer";
export const VEHICLE_EQUIPMENT = Domain + "portal/vehicle_equipments";
export const VEHICLE_ORDERS = Domain + "portal/vehicle_orders";
export const INSPECTION = Domain + "portal/inspections";
export const TRANSFER_ORDERS_FROM_VEHICLE_TO_VEHICLE =
  Domain + "portal/vehicle_orders/transfer";
export const EQUIPMENT_STATUSES = Domain + "portal/equipment_statuses";
export const POST_ORDERS_TO_VEHICLE = Domain + "portal/vehicle_orders";
export const DELETE_ORDER_FROM_VEHICLE = Domain + "portal/vehicle_orders";
export const GET_ALL_DOOR_STEP_CATEGORIES =
  Domain + "portal/doorstep-service-categories?type=main";
export const VEHICLE_ASSIGNS = Domain + "portal/vehicles";
export const UPDATE_DOOR_STEP_CATEGORIES =
  Domain + "portal/doorstep-service-categories/";
export const ADD_DOOR_STEP_CATEGORIES = Domain + "service_categories";
export const DELETE_DOOR_STEP_SERVICE = Domain + "door_step_services/";
export const GET_DOOR_STEP_SUB_CATEGORY =
  Domain + "portal/doorstep-service-categories";
export const CATEGORIES_TYPES = Domain + "service_category_types";
export const ORDERS_STATUSES = Domain + "portal/orders_statuses";
export const Agent_Card = Domain + "portal/operators?category=agent";
export const Assign_Agent = Domain + "portal/agent_orders/assign";
export const GetAllPermission = Domain + "portal/permissions";
export const GetAllRoles = Domain + "portal/operator/categories";
export const GET_ALL_ROLES =
  "https://estbn.com/EstbnNew/public/api/portal/roles";
export const SYNC_PERMISSION_TO_ROLL =
  "https://estbn.com/EstbnNew/public/api/portal/role/sync_permissions";
export const SYNC_PERMISSION_TO_User = Domain + "portal/user/sync_permissions";
export const SYNC_ROLE_TO_USER =
  "https://estbn.com/EstbnNew/public/api/portal/user/sync_roles";
export const CREATE_NEW_OPRATOR = Domain + "portal/operators";
export const LOG_OUT = Domain + "portal/operator/logout";
export const REGISTER_USER = Domain + "portal/operators";
export const GET_ALL_USER_PERMISSIONS = Domain + "portal/user/permissions";
export const GET_ALL_USER_Roles =
  "https://estbn.com/EstbnNew/public/api/portal/user/roles";
export const AGENT_ORDERS = Domain + "portal/vehicle_orders";
export const SERVICES_OFFERS = Domain + "door_step_offers";
